import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.v2.js";
import "core-js/modules/esnext.set.union.js";
import Cookies from "js-cookie";
import { config } from "shared/data";
import { detectAdBlock } from "shared/lib/ad-block";
import { gtag } from "shared/lib/gtag";
const getGAIdFromCookie = () => {
  const gaValue = Cookies.get("_ga");
  if (!gaValue) return null;

  // GA cookie format: GA1.1.1234567890.1234567890
  const parts = gaValue.split(".");
  if (parts.length >= 2) {
    return parts.slice(-2).join(".");
  }
  return null;
};
export const getGoogleAnalyticsClientIdSync = () => {
  var _ga, _ga$getAll;
  if (typeof ga === "undefined") return;
  const instance = (_ga = ga) === null || _ga === void 0 || (_ga$getAll = _ga.getAll) === null || _ga$getAll === void 0 || (_ga$getAll = _ga$getAll.call(_ga)) === null || _ga$getAll === void 0 ? void 0 : _ga$getAll[0];
  if (!instance) return;
  return instance.get("clientId");
};
export const getGoogleAnalyticsClientId = async () => getGoogleAnalyticsClientIdSync() ?? (await getGAClientIdFromGTM(config.googleAnalytics.measurementId)) ?? getGAIdFromCookie() ?? "";
export function computeGACampaignKey(name, variant) {
  const skippedVariant = new Set(["0", "1"]);
  return skippedVariant.has(variant) ? name : `${name}-${variant}`;
}
let getGaClientIdFromGTMPromise;
export async function getGAClientIdFromGTM(profileId) {
  if (getGaClientIdFromGTMPromise !== undefined) return getGaClientIdFromGTMPromise;
  const hasAdBlock = await detectAdBlock();
  getGaClientIdFromGTMPromise = hasAdBlock ? Promise.resolve(undefined) : new Promise(resolve => {
    setTimeout(() => {
      resolve(undefined);
    }, 5000);
    gtag("get", profileId, "client_id", clientId => resolve(clientId));
  });
  return getGaClientIdFromGTMPromise;
}